'use strict';

var GridBasicExampleDirective = function GridBasicExampleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-basic-example.html'),
    controller: 'GridBasicExampleController',
    scope: {
      data: '='
    }
  };
};
GridBasicExampleDirective.$inject = [];
module.exports = GridBasicExampleDirective;